import React from "react";

const Question = ({ question, onChange, errors, index, isAnswer = false }) => {
    const handleAnswerChange = (e) => {
        const updatedAnswer = e.target.value;
        if (onChange) {
            onChange(index, updatedAnswer);
        }
    };

    const handleCheckboxChange = (e) => {
        const updatedAnswer = e.target.checked ? e.target.value : "";
        if (onChange) {
            onChange(index, updatedAnswer);
        }
    };

    switch (question.value) {
        case "multipleChoice":
            return (
                <div className="mx-auto mb-8 space-y-2">
                    <h1 className="mb-2 text-base font-medium text-grey-900">
                        {question.questionTitle}
                    </h1>
                    {question.options.map((option, optionIndex) => (
                        <div key={optionIndex} className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                value={option}
                                checked={question.answer === option}
                                onChange={handleCheckboxChange}
                                className="w-4 h-4 rounded border-grey-300 accent-primary-600"
                            />
                            <label className="text-xs text-grey-900">
                                <span className="text-sm text-grey-900">{option}</span>
                            </label>
                        </div>
                    ))}
                    {errors && errors[question.value] && (
                        <p className="text-error-500 text-sm mt-1">{errors[question.value]}</p>
                    )}
                </div>
            );

        case "shortAnswer":
            return (
                <div className="flex flex-col gap-2 mb-4">
                    <label className="text-base font-medium text-grey-900">{question.questionTitle}</label>
                    {isAnswer ? <p className="text-sm font-normal md:w-1/2">{question?.answer}</p> :
                        <input
                            type="text"
                            value={question.answer}
                            onChange={handleAnswerChange}
                            placeholder="Type your answer"
                            className="w-6/12 p-2 border rounded-lg border-grey-300"
                        />
                    }
                    {errors && errors[question.value] && (
                        <p className="text-error-500 text-sm mt-1">{errors[question.value]}</p>
                    )}
                </div>
            );

        case "longAnswer":
            return (
                <div className="flex flex-col gap-2">
                    <label className="text-base font-medium text-grey-900">{question.questionTitle}</label>
                    {isAnswer ? <p className="text-sm font-normal md:w-1/2">{question?.answer}</p> :
                        <textarea
                            value={question.answer}
                            onChange={handleAnswerChange}
                            placeholder="Type your detailed answer"
                            className="w-6/12 p-2 border rounded-lg border-grey-300"
                            rows={4}
                        />
                    }
                    {errors && errors[question.value] && (
                        <p className="text-error-500 text-sm mt-1">{errors[question.value]}</p>
                    )}
                </div>
            );

        default:
            return null;
    }
};

export default Question;